import { faEnvelopeCircleCheck } from '@fortawesome/pro-light-svg-icons'
import { EmployeeNotificationLogTypeKeys, EmployeeNotificationModelType } from '@teinor/erp/types/company/userInner/employee/employeeNotification'
import { useCallback, useEffect, useState } from 'react'
import { ConnectedProps, connect } from 'react-redux'
import { ButtonSecondary } from '../../../../../../../baseComponents/Button'
import { DisplayStatusWithoutIcon } from '../../../../../../../baseComponents/Displays/DisplayStatus'
import TwinIcon from '../../../../../../../baseComponents/TwinIcon'
import { TwinSimpleTable } from '../../../../../../../baseComponents/TwinTable'
import { TableComponentProps } from '../../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { TableInstanceType } from '../../../../../../../baseComponents/TwinTable/types'
import { CustomRenderDate, CustomRenderString } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import { twinFetchPostJSON } from '../../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import useEditDeleteModal from '../../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxAppPayloads, GlobalContext } from '../../../../../../../utils/reducers'
import { LastNotificationPayload } from '../../../../../../../utils/reducers/company/lastNotification'
import { changeLastNotification } from '../../../../../../../utils/reducers/reduxDispatch'
import { parseExtraDataDatesNotification } from './functions'
import ModalAllNotificationsEmployee from './ModalAllNotificationsEmployee'

type AllNotificationsProps = TableAllNotificationsProps & {
    extraProps?: TwinDictionary
}

const AllNotifications: React.FC<AllNotificationsProps> = ({ userPermissions, extraProps }) => {
    const { openModal, setOpenModal, setTableInstance, tableInstance, refreshTableData, checkAllNotifications } = useAllNotificationsLogic({extraProps})

    return (
        <div className={'flex flex-col flex-auto h-1 all_notifications_employee'}>
            <div className='table_header flex justify-between items-center mb-40 flex-wrap gap-10'>
                <span className='regular18 '><TwinTrans transKey='allNotifications'>Todas las notificaciones</TwinTrans></span>
                <div className='right_side grid_header_table items-center flex flex-wrap gap-x-15 gap-y-10'>
                    <ButtonSecondary onClick={checkAllNotifications}>
                        <TwinIcon icon={faEnvelopeCircleCheck} className='mr-8' size='lg' />
                        <TwinTrans transKey={'checkAllReaded'} >Marcar todas como leídas</TwinTrans>
                    </ButtonSecondary>
                </div>
            </div>
            <div className='flex-auto flex flex-col'>
                <TableAllNotificationsConnect setTableInstance={setTableInstance} userPermissions={userPermissions} setOpened={setOpenModal} tableInstance={tableInstance} extraProps={extraProps} />
                {openModal?.type === 'edit' ? <ModalAllNotificationsEmployee onSubmit={refreshTableData} setOpened={() => setOpenModal(null)} allRowData={openModal?.allRowData} userPermissions={userPermissions}/> : null}
            </div>
        </div>
    )
}

interface useAllNotificationsLogicProps {
    extraProps?: TwinDictionary
}

const useAllNotificationsLogic = ({ extraProps }: useAllNotificationsLogicProps) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    const [tableInstance, setTableInstance] = useState<TableInstanceType>(null)
    const refreshTableData = useCallback(() => {
        tableInstance?.getTableDataFromStart()
    }, [tableInstance])

    const checkAllNotifications = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/employee/employeeNotification/markAsReadFromNow', extraProps?.where )
        if (result) {
            tableInstance?.getTableDataFromStart()
            changeLastNotification(null)
        }
    }, [tableInstance, extraProps?.where])


    return { openModal, setOpenModal, tableInstance, setTableInstance, refreshTableData, checkAllNotifications }
}


type TableAllNotificationsProps = TableComponentProps & TableAllNotificationsLogicProps & {
    extraProps?: TwinDictionary
}

const TableAllNotifications: React.FC<TableAllNotificationsProps> = ({ setOpened, setTableInstance, lastNotification, tableInstance, extraProps, ...rest}) => {
    const { t } = useTwinTranslation()
    useTableAllNotificationsLogic({lastNotification, tableInstance, tableName: extraProps?.tableName, ...rest})
    const dictLogTypes: Record<EmployeeNotificationLogTypeKeys, string> = {
        0: t('holiday', 'Vacaciones'),
        1: t('holiday', 'Vacaciones'),
        2: t('holiday', 'Vacaciones'),
        3: t('holiday', 'Vacaciones'),
        4: t('absence', 'Ausencias'),
        5: t('absence', 'Ausencias'),
        6: t('absence', 'Ausencias'),
        7: t('absence', 'Ausencias'),
        8: t('absence', 'Ausencias'),
        9: t('absence', 'Ausencias'),
        10: t('payslips', 'Nóminas'),
        11: t('expenses', 'Gastos'),
        12: t('expenses', 'Gastos'),
        13: t('expenses', 'Gastos'),
        14: t('expenses', 'Gastos'),
        15: t('expenses', 'Gastos'),
        16: t('projects', 'Proyectos'),
        17: t('projects', 'Proyectos'),
        18: t('task', 'Tarea'),
        19: t('task', 'Tarea'),
        20: t('task', 'Tarea'),
        21: t('task', 'Tarea'),
        22: t('task', 'Tarea'),
        23: t('task', 'Tarea'),
        24: t('projects', 'Proyectos'),
        25: '',
        26: '',
        27: '',
        28: t('overtime', 'Horas extra'),
        29: t('overtime', 'Horas extra'),
        30: t('overtime', 'Horas extra'),
        31: t('overtime', 'Horas extra'),
        32: t('overtime', 'Horas extra'),
        33: t('overtime', 'Horas extra'),
        34: t('overtime', 'Horas extra'),
        35: t('overtime', 'Horas extra'),
        36: t('overtime', 'Horas extra'),
        37: t('taskBagOfHours', 'Bolsa de horas'),
        38: t('taskBagOfHours', 'Bolsa de horas'),
        39: t('quoteOrders', 'Presupuestos'),
        40: t('quoteOrders', 'Presupuestos'),
        41: t('quoteOrders', 'Presupuestos'),
        42: t('quoteOrders', 'Presupuestos')
    }
    const columns: ColumnTableSchema<EmployeeNotificationModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: '',
            width: 40,
            customRender: (parameterValue, allRowData) => {return allRowData?.readed ? <div></div> : <div className={'w-3 h-3 rounded-xl bg-green-43'}></div>}
        },
        {
            id: 'createdAt',
            dataKey: 'createdAt',
            label: t('date', 'Fecha'),
            sortable: true,
            width: 100,
            customRender: (parameterValue, allRowData) => <CustomRenderDate className={allRowData?.readed ? '' : 'font-bold' } value={parameterValue} />
        },
        {
            id: 'title',
            dataKey: 'logType',
            label: t('title', 'Título'),
            width: 250,
            customRender: (parameterValue, allRowData) => <RenderLogTypeTitle value={parameterValue} isRead={allRowData?.readed} />
        },
        {
            id: 'message',
            dataKey: 'extraData',
            label: t('message', 'Mensaje'),
            minWidth: 500,
            customRender: (parameterValue, allRowData) => <RenderLogTypeMessage value={parameterValue} logType={allRowData?.logType} employeeTrigger={allRowData?.EmployeeTrigger?.fullname_short} isRead={allRowData?.readed} />
        },
        {
            id: 'logType',
            dataKey: 'logType',
            minWidth: 150,
            label: t('category', 'Categoría'),
            generalSearchable: false,
            customRender: (parameterValue, allRowData) => <DisplayStatusWithoutIcon colorText={'text-green-21'} text={dictLogTypes[parseInt(parameterValue) as EmployeeNotificationLogTypeKeys ]} />
        },
    ]
    return (
        <TwinSimpleTable name='AllNotifications' columns={columns} defaultOrder={{ defaultOrderField: 'createdAt', order: 'desc' }} getDataFrom='/api/app/employee/employeeNotification/getAllEmployeeNotifications' setTableInstance={setTableInstance} onRowClick={(_id, rowData) => setOpened({
            type: 'edit',
            allRowData: rowData
        })} extraWhereParams={extraProps?.where || undefined}/>
    )
}

interface TableAllNotificationsLogicProps extends ReduxLastNotification {
    lastNotification: LastNotificationPayload
    tableInstance: TableInstanceType
    tableName?: string
}

const useTableAllNotificationsLogic = ({ lastNotification, tableInstance, tableName}: TableAllNotificationsLogicProps) => {
    useEffect(() => {
        if (lastNotification?.id) {
            tableInstance?.getTableDataFromStart()
        }
    }, [lastNotification?.id, tableInstance])
    useEffect(() => {
        if (tableInstance) {
            tableInstance?.getTableDataFromStart()
        }
    }, [tableName, tableInstance])
}

interface RenderLogTypeTitleProps {
    value: string
    isRead: boolean
}

const RenderLogTypeTitle: React.FC<RenderLogTypeTitleProps> = ({ value, isRead }) => {
    const { t } = useTwinTranslation()
    const requestStatusTypesDic: TwinDictionary = {
        0:  t('holidayRequest', 'Vacaciones solicitadas'),
        1:  t('holidayApproved', 'Vacaciones aprobadas'),
        2:  t('holidayDenied', 'Vacaciones denegadas'),
        3:  t('holidayCancel', 'Vacaciones canceladas'),
        4:  t('absenceRequest', 'Ausencia solicitada'),
        5:  t('absenceApproved', 'Ausencia aprobada'),
        6:  t('absenceDenied', 'Ausencia denegada'),
        7:  t('absenceCancel', 'Ausencia cancelada'),
        8:  t('absenceProofFile', 'Ausencia justificada'),
        9: t('absenceCancel', 'Ausencia cancelada'),
        10: t('payslipReceived', 'Nómina recibida'),
        11: t('expenseRequest', 'Solicitud de gastos'),
        12: t('expenseDenied', 'Gastos denegados'),
        13: t('expenseAccepted', 'Gastos aceptados'),
        14: t('expensePaid', 'Gastos pagados'),
        15: t('expenseReceived', 'Gasto recibido'),
        16: t('commentAddedProject', 'Comentario añadido'),
        17: t('newStatusProject', 'Estado modificado'),
        18: t('changedEmployeeTask', 'Cambio de empleado en la tarea'),
        19: t('changedGroupTask', 'Cambio de grupo en la tarea'),
        20: t('finishedTask', 'Tarea finalizada'),
        21: t('reopenTask', 'Reabrir tarea'),
        22: t('changesTask', 'Cambios en la tarea'),
        23: t('addTaskComment', 'Añadido comentario en la tarea'),
        24: t('modifiedProjectType', 'Tipo de proyecto modificado'),
        28: t('overtimeRequest', 'Solicitud de horas extra'),
        29: t('overtimeRequest', 'Solicitud de horas extra'),
        30: t('overtimeApprovedShort', 'Horas extra aprobadas'),
        31: t('overtimeApprovedShort', 'Horas extra aprobadas'),
        32: t('overtimeCancel', 'Horas extra canceladas'),
        33: t('overtimeDeniedShort', 'Horas extra denegadas'),
        34: t('overtimeDeniedShort', 'Horas extra denegadas'),
        35: t('overtimePaid', 'Se han pagado las horas extra'),
        36: t('overtimeCreatedHolidaysShort', 'Se han generado vacaciones'),
        37: t('shortTimeLeft', 'Poco tiempo restante'),
        38: t('finishedTaskBagOFHours', 'Bolsa de horas finalizada'),
        39: t('newComment', 'Nuevo comentario'),
        40: t('acceptedQuoteOrder', 'Presupuesto aceptado'),
        41: t('deniedQuoteOrder', 'Presupuesto cancelado'),
        42: t('changesRequest', 'Solicitud de cambios')
    }

    const parsedValue = parseInt(value)
    return <CustomRenderString className={isRead ? '' : 'font-bold'} value={requestStatusTypesDic[parsedValue]} />
}

interface RenderLogTypeMessageProps {
    value: string
    isRead: boolean
    logType: number
    employeeTrigger: string
}

export const RenderLogTypeMessage: React.FC<RenderLogTypeMessageProps> = ({ value, isRead, logType, employeeTrigger }) => {
    const { tVars } = useTwinTranslation()
    const extraDataParsed = JSON.parse(value)
    const options = { employeeTrigger, ...extraDataParsed, ...parseExtraDataDatesNotification(extraDataParsed) }
    const requestStatusTypesDic: TwinDictionary = {
        0: tVars('holidayRequestMessage', '{{employeeTrigger}} ha solicitado vacaciones del {{fromDate}} al {{toDate}}', options),
        1: tVars('holidayApprovedMessage', '{{employeeTrigger}} te ha aprobado las vacaciones del {{fromDate}} al {{toDate}}', options),
        2: tVars('holidayDeniedMessage', '{{employeeTrigger}} te ha denegado las vacaciones del {{fromDate}} al {{toDate}}', options),
        3: tVars('holidayCancelMessage', '{{employeeTrigger}} te ha cancelado las vacaciones del {{fromDate}} al {{toDate}}', options),
        4: tVars('absenceRequestMessage', '{{employeeTrigger}} ha solicitado una ausencia del {{fromDate}} al {{toDate}}', options),
        5: tVars('absenceApprovedMessage', '{{employeeTrigger}} te ha aprobado una ausencia del {{fromDate}} al {{toDate}}', options),
        6: tVars('absenceDeniedMessage', '{{employeeTrigger}} te ha denegado una ausencia del {{fromDate}} al {{toDate}}', options),
        7: tVars('absenceCancelMessage', '{{employeeTrigger}} te ha cancelado una ausencia del {{fromDate}} al {{toDate}}', options),
        8: tVars('absenceProofFileMessage', '{{employeeTrigger}} ha adjuntado un fichero en una ausencia', options),
        9: tVars('absenceSelfCancelMessage', '{{employeeTrigger}} ha cancelado su ausencia del {{fromDate}} al {{toDate}}', options),
        10: tVars('payslipReceivedMessage', 'Has recibido la nómina del {{fromDate}} al {{toDate}}', options),
        11: tVars('expenseRequestMessage', '{{employeeTrigger}} ha enviado una ficha de gastos del {{fromDate}} al {{toDate}}', options),
        12: tVars('expenseDeniedMessage', 'Han denegado la ficha de gastos del {{fromDate}} al {{toDate}}', options),
        13: tVars('expenseAcceptedMessage', 'Han aceptado la ficha de gastos del {{fromDate}} al {{toDate}}', options),
        14: tVars('expensePaidMessage', 'Han pagado la ficha de gastos del {{fromDate}} al {{toDate}}', options),
        15: tVars('expenseReceivedMessage', 'Has recibido una ficha de gastos del {{fromDate}} al {{toDate}}', options),
        16: tVars('commentAddedMessage', '{{employeeTrigger}} ha dejado un comentario en el proyecto {{projectName}}', options),
        17: tVars('newStatusProjectMessage', '{{employeeTrigger}} ha realizado una modificación en el estado del proyecto {{projectName}}', options),
        18: options.employeeName ? options.customerName ? tVars('changedEmployeeTaskMessageWithCustomer', '{{employeeTrigger}} ha asignado a {{employeeName}} la tarea #{{taskId}} de {{customerName}}', options) : tVars('changedEmployeeTaskMessage', '{{employeeTrigger}} ha asignado a {{employeeName}} la tarea #{{taskId}}', options) : options.customerName ? tVars('changedNoEmployeeTaskMessageWithCustomer', '{{employeeTrigger}} ha quitado el empleado asignado a la tarea #{{taskId}} de {{customerName}}', options) : tVars('changedNoEmployeeTaskMessage', '{{employeeTrigger}} ha quitado el empleado asignado a la tarea #{{taskId}}', options),
        19: options.groupName ? options.customerName ? tVars('changedGroupTaskMessageWithCustomerName2', '{{employeeTrigger}} ha asignado a {{groupName}} la tarea #{{taskId}} de {{customerName}}', options) : tVars('changedGroupTaskMessage2', '{{employeeTrigger}} ha asignado a {{groupName}} la tarea #{{taskId}}', options) : options.customerName ? tVars('changedNoGroupTaskMessageWithCustomerName', '{{employeeTrigger}} ha quitado el grupo asignado a la tarea #{{taskId}} de {{customerName}}', options) : tVars('changedNoGroupTaskMessage', '{{employeeTrigger}} ha quitado el grupo asignado a la tarea #{{taskId}}', options),
        20: options.customerName ? tVars('finishedTaskMessageWithCustomerName', '{{employeeTrigger}} ha finalizado la tarea #{{taskId}} de {{customerName}}', options) : tVars('finishedTaskMessage', '{{employeeTrigger}} ha finalizado la tarea #{{taskId}}', options),
        21: options.customerName ? tVars('unfinishedTaskMessageWithCustomer', '{{employeeTrigger}} ha reabierto la tarea #{{taskId}} de {{customerName}}', options) : tVars('unfinishedTaskMessage', '{{employeeTrigger}} ha reabierto la tarea #{{taskId}}', options),
        22: options.customerName ? tVars('changedTaskCFieldMessageWithCustomer', '{{employeeTrigger}} ha cambiado a {{customField}} {{customFieldValue}} la tarea #{{taskId}} de {{customerName}}', options) : tVars('changedTaskCFieldMessage', '{{employeeTrigger}} ha cambiado a {{customField}} {{customFieldValue}} la tarea #{{taskId}}', options),
        23: options.customerName ? tVars('addTaskCommentMessageWithCustomer', '{{employeeTrigger}} ha añadido un comentario en la tarea #{{taskId}} de {{customerName}}', options) : tVars('addTaskCommentMessage', '{{employeeTrigger}} ha añadido un comentario en la tarea #{{taskId}}', options) ,
        24: tVars('changedProjectTypeMessage', '{{employeeTrigger}} ha modificado el tipo de proyecto en el proyecto {{projectName}}', options),
        28: tVars('overtimeRequestByAdminMessage', '{{employeeTrigger}} ha solicitado horas extra para el día {{day}}', options),
        29: tVars('overtimeRequestByUserMessage', 'El empleado {{employeeTrigger}} ha solicitado horas extra para el día {{day}}', options),
        30: tVars('overtimeApprovedByAdminMessage', '{{employeeTrigger}} ha aprobado las horas extra del día {{day}}', options),
        31: tVars('overtimeAcceptedByUserMessage', 'El empleado {{employeeTrigger}} ha aceptado las horas extra del día {{day}}', options),
        32: tVars('overtimeCancelMessage', '{{employeeTrigger}} ha cancelado las horas extra del día {{day}}', options),
        33: tVars('overtimeDeniedByAdminMessage', '{{employeeTrigger}} ha denegado las horas extra del día {{day}}', options),
        34: tVars('overtimeDeniedByUserMessage', 'El empleado {{employeeTrigger}} ha denegado las horas extra del día {{day}}', options),
        35: tVars('overtimeMarkAsPaidMessage', 'Se han marcado como pagadas las horas extra del día {{day}}', options),
        36: tVars('overtimeMarkAsCreatedHolidaysMessage', 'Se han marcado como devuelto en vacaciones las horas extra del día {{day}}', options),
        37: tVars('less20PercentTaskBagOfHoursMessage', 'A la bolsa de horas {{taskBagOfHoursName}} del cliente {{customerName}} le queda menos del 20% de tiempo', options),
        38: tVars('finishedTaskBagOfHoursMessage', 'La bolsa de horas {{taskBagOfHoursName}} del cliente {{customerName}} se ha acabado', options),
        39: tVars('customerHasAddedNewCommentInYourQuoteOrder', '{{customerName}} ha añadido un nuevo comentario en tu prespuesto {{quoteOrder}}', options),
        40: tVars('customerHasAcceptedYourQuoteOrder', '{{customerName}} ha aceptado tu prespuesto {{quoteOrder}}', options),
        41: tVars('customerHasDeniedYourQuoteOrder', '{{customerName}} ha cancelado tu prespuesto {{quoteOrder}}', options),
        42: tVars('quoteOrderChangesRequestByCustomer', '{{customerName}} ha solicitado cambios en tu presupuesto {{quoteOrder}}', options)
    }

    return <CustomRenderString className={isRead ? '' : 'font-bold'} value={requestStatusTypesDic[logType]} />
}

const lastNotificationDispatch = {
    setLastNotification: (payload: LastNotificationPayload) => ({ type: 'CHANGE_LAST_NOTIFICATION', payload })
}

export type ReduxLastNotification = ConnectedProps<typeof lastNotificationConnect>
const mapLastNotificationConnector = (state: AllReduxAppPayloads) => ({ lastNotification: state.lastNotification })
const lastNotificationConnect = connect(mapLastNotificationConnector, lastNotificationDispatch, null, { context: GlobalContext })

const TableAllNotificationsConnect = lastNotificationConnect(TableAllNotifications)

export default AllNotifications